import SharedDialog, {
  SharedDialogControls,
} from "../Layout/Dialog/SharedDialog";
import PdsrCsvFileUploader from "./PdsrCsvFileUploader";

interface Props {
  readonly isOpen: boolean;
  readonly handleCancelButtonClick: () => void;
  readonly handleOkButtonClick: () => void;
}

export default function UploadDialog({
  isOpen,
  handleCancelButtonClick,
  handleOkButtonClick,
}: Props) {
  return (
    <SharedDialog
      title="PDSR CSV Upload"
      subtitle=""
      isOpen={isOpen}
      handleClose={handleCancelButtonClick}
      width="md"
    >
      <p>
        Select a file. The file is checked before uploading and is not uploaded
        immediately.
      </p>
      <PdsrCsvFileUploader />
      <SharedDialogControls>
        <button
          onClick={handleOkButtonClick}
          type="submit"
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
        >
          close
        </button>
      </SharedDialogControls>
    </SharedDialog>
  );
}
